const generateYears = () => {
  const currentYear = new Date().getFullYear();
  const result = [];

  for (let i = 0; i < 3; i += 1) {
    result.push(currentYear + i);
  }

  return result;
};

const years = generateYears();

const months = [
  {
    label: "Januari",
    value: "1",
  },
  {
    label: "Februari",
    value: "2",
  },
  {
    label: "Maart",
    value: "3",
  },
  {
    label: "April",
    value: "4",
  },
  {
    label: "Mei",
    value: "5",
  },
  {
    label: "Juni",
    value: "6",
  },
  {
    label: "Juli",
    value: "7",
  },
  {
    label: "Augustus",
    value: "8",
  },
  {
    label: "September",
    value: "9",
  },
  {
    label: "Oktober",
    value: "10",
  },
  {
    label: "November",
    value: "11",
  },
  {
    label: "December",
    value: "12",
  },
];

const days = Array.from(new Array(31), (val, index) => index + 1);

export { days, months, years };
